<template>
	<div ref="mainnav" class="navbar">
		<div></div>
		<div class="d-flex justify-content-between align-items-center">
			<b-dropdown size="sm" toggle-class="language-button" right no-caret>
				<template slot="button-content">
					<template v-for="(item, index) in localeOption">
						<template v-if="item.id === $i18n.locale">
							<b-img alt="img_language" :key="`img_${index}`" :src="item.icon" width="18"
								style="margin-bottom: 2px" />
							<span class="name mx-1 d-none d-md-inline-block" :key="`span_${index}`">{{ item.name
								}}</span>
						</template>
					</template>
				</template>
				<div class="section-wrapper mx-2" style="width: 200px">
					<b-dropdown-item v-for="(_item, index) in localeOption" :key="index"
						@click="changeLocale(_item.id)">
						<div class="w-100 d-flex justify-content-between item-hover align-items-center">
							<div>
								<b-img alt="img_language" :src="_item.icon" width="18" />
								<span class="ml-2">{{ _item.name }}</span>
							</div>
							<i v-if="_item.id == $i18n.locale" class="fas fa-check-circle fa-sm float-right"
								style="color: #ff0000"></i>
						</div>
					</b-dropdown-item>
				</div>
			</b-dropdown>
			<!-- <div class="mr-4" id="popover-button-notify" style="width: 24px; height: 24px;">
        <i class="fas fa-bell mx-3 pointer" tabindex="0" style="color: #6b6f80; font-size: 20px"></i>
      </div> -->
			<div class="notify-bounder mx-3">
				<div id="popover-button-notify" tabIndex="0" class="avatar-icon pointer"
					:style="`background-image: url('/assets/image/NLT-INFO/header-bell.svg'); width: 20px`"></div>
			</div>

			<div id="popover-button-user" class="avatar-icon pointer"
				:style="`background-image: url('/assets/image/NLT-INFO/avatar.svg'); width: 24px`" tabindex="1"></div>

			<!-- event notify popover -->

			<b-popover ref="popover-button-notify" target="popover-button-notify" triggers="focus"
				placement="bottomleft" boundary-padding="40" custom-class="wide-popover-notify">
				<div class="d-flex justify-content-between px-2 pt-2 w-100"
					@click="$refs['popover-button-notify'].$emit('close')">
					<span class="text-14-semibold pointer">{{ $t('tin-tuc-su-kien') }}</span>
					<span class="text-14 text-danger pointer underline-hover" @click="setLeftMenuIndex(3)">{{
						$t('xem-tat-ca')
					}}</span>
				</div>
				<div class="list-notify-container">
					<div v-for="(item, index) in topPost.Data" :key="index" @click="showNewsHandler(item)"
						class="section-wrapper pointer item-hover p-2 mb-2 text-14">
						<div class="news-card text-muted d-flex justify-content-between">
							<div class="d-flex">
								<img class="pr-1" src="/assets/image/NLT-INFO/event-icon.svg" />
								<div class="limit-title">{{ item.PostTypeName }}</div>
							</div>
							<span class="text-muted">{{ convertDate(item.CreateDate) }}</span>
						</div>
						<div class="pt-2 font-weight-semibold">{{ item.Title }}</div>
						<div>{{ item.ShortContent }}</div>
						<div v-if="item.Avatar" class="pt-2">
							<ImageCard :url="item.Avatar" :ratio="260 / 168"></ImageCard>
						</div>



					</div>

				</div>
			</b-popover>

			<!-- user info popover -->

			<b-popover ref="popover-button-user" target="popover-button-user" triggers="focus" placement="bottomleft"
				boundary-padding="40" custom-class="wide-popover-authen">
				<div class="w-100 text-14">
					<div class="section-wrapper d-flex justify-content-between align-items-center px-2 pb-2 pt-1 m-2">
						<div class="d-flex text-left">
							<div class="avatar-icon pointer mr-2"
								:style="`background-image: url('/assets/image/NLT-INFO/avatar.svg'); width: 48px`">
							</div>
							<div v-if="isLoggedIn">
								<div class="text-18 pointer">{{ currentUser.FullName }}</div>
								<div class="text-14">{{ currentUser.UserPhone }}</div>
							</div>
							<div v-else>
								<div class="text-danger text-18 pointer" @click="$bvModal.show('login-modal')">{{
									$t('dang-nhap-dang-ky') }}</div>
								<div class="text-14">{{ $t('enhance-experience') }}</div>
							</div>
						</div>
						<i v-if="isLoggedIn" class="fas fa-chevron-right pointer" @click="viewUserInfo"
							style="color: #6b6f80; font-size: 16px"></i>
					</div>
					<div class="section-wrapper m-2" @click="$refs['popover-button-user'].$emit('close')">
						<div v-if="isLoggedIn" @click="$bvModal.show('change-password-modal')"
							class="item-hover px-2 d-flex align-items-center justify-content-between pointer py-2 border-bottom-item">
							{{ $t('doi-mat-khau') }}
							<i class="fas fa-chevron-right" style="color: #6b6f80; font-size: 16px"></i>
						</div>
						<div @click="setLeftMenuIndex(4)"
							class="item-hover px-2 d-flex align-items-center justify-content-between pointer py-2 border-bottom-item">
							{{ $t('gop-y-phan-hoi') }}
							<i class="fas fa-chevron-right" style="color: #6b6f80; font-size: 16px"></i>
						</div>
						<div @click="getInfoCompany"
							class="item-hover px-2 d-flex align-items-center justify-content-between pointer py-2 border-bottom-item">
							{{ $t('thong-tin-nha-phat-trien') }}
							<i class="fas fa-chevron-right" style="color: #6b6f80; font-size: 16px"></i>
						</div>
						<div class="item-hover px-2 d-flex align-items-center justify-content-between pointer py-2">
							{{ $t('phien-ban') }}
							<span class="text-muted">2024.08.29</span>
						</div>
					</div>
					<div class="mx-2 mb-2">
						<b-button v-if="isLoggedIn" @click="$bvModal.show('logout-modal')"
							class="w-100 btn-general text-14"> {{
								$t('dang-xuat') }}</b-button>
					</div>
				</div>
			</b-popover>

			<!-- login/register -->

			<b-modal id="login-modal" body-class="p-2" header-class="p-2" size="small" hide-footer centered
				:title="authenTabIndex == 0 ? $t('dang-nhap') : $t('dang-ky')"
				title-class="text-16-semibold text-center w-100">
				<b-tabs v-model="authenTabIndex" nav-class="d-none">
					<b-tab class="b-tab-container">
						<b-form @submit="onSubmitLogin" autocomplete="off">
							<b-form-group :label="$t('form_email_phone')" label-class="label-class">
								<b-form-input :state="loginFormState.name" class="form-control bg-white"
									v-model="loginForm.name" autocomplete="on" :placeholder="$t('email-phone-input')" />
								<b-form-invalid-feedback class="text-12-semibold p-0 m-0"> {{
									$t('vui-long-nhap-email-so-dien-thoai') }} </b-form-invalid-feedback>
							</b-form-group>
							<b-form-group :label="$t('form-password')" label-class="label-class">
								<div class="icon-input">
									<b-form-input :state="loginFormState.pass" autocomplete="on"
										class="form-control bg-white pr-4" :type="`${showPass ? 'text' : 'password'}`"
										v-model="loginForm.pass" :placeholder="$t('input-password')" />
									<span @click="showPass = !showPass">
										<img v-if="showPass" src="assets/image/icon/eye.svg" height="16px" />
										<img v-else src="assets/image/icon/eye-off.svg" height="16px" />
									</span>
									<b-form-invalid-feedback class="text-12-semibold p-0 m-0"> {{
										$t('vui-long-nhap-mat-khau') }}
									</b-form-invalid-feedback>
								</div>
							</b-form-group>

							<b-button class="w-100 btn-general text-14 mt-2" type="submit">{{ $t('dang-nhap')
								}}</b-button>
							<div class="text-14 text-center pt-1">
								{{ $t('ban-chua-co-tai-khoan') }}
								<span class="text-14-semibold text-danger pointer" @click="authenTabIndex = 1">{{
									$t('dang-ky')
								}}</span>
							</div>
						</b-form>
					</b-tab>
					<b-tab class="b-tab-container">
						<b-form @submit="onSubmitRegister" autocomplete="off">
							<b-form-group :label="'Email'" label-class="label-class">
								<b-form-input class="form-control bg-white" v-model="registerForm.email"
									:state="registerFormState.email" :placeholder="$t('input-email')"
									autocomplete="on" />
								<b-form-invalid-feedback class="text-12-semibold p-0 m-0"> {{ $t('vui-long-nhap-email')
									}}
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group :label="$t('so-dien-thoai')" label-class="label-class">
								<b-form-input class="form-control bg-white" v-model="registerForm.phone"
									:state="registerFormState.phone" autocomplete="on"
									:placeholder="$t('input-phone-number')" />
								<b-form-invalid-feedback class="text-12-semibold p-0 m-0"> {{
									$t('vui-long-nhap-so-dien-thoai') }}
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group :label="$t('user-name')" label-class="label-class">
								<b-form-input class="form-control bg-white" v-model="registerForm.username"
									:state="registerFormState.username" autocomplete="on"
									:placeholder="$t('input-user-name')" />
								<b-form-invalid-feedback class="text-12-semibold p-0 m-0"> {{
									$t('vui-long-nhap-ten-nguoi-dung') }}
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group :label="$t('form-password')" label-class="label-class">
								<div class="icon-input">
									<b-form-input :state="registerFormState.pass" autocomplete="on"
										class="form-control bg-white pr-4" :type="`${showPass ? 'text' : 'password'}`"
										v-model="registerForm.pass" :placeholder="$t('input-password')" />
									<span @click="showPass = !showPass">
										<img v-if="showPass" src="assets/image/icon/eye.svg" height="16px" />
										<img v-else src="assets/image/icon/eye-off.svg" height="16px" />
									</span>
									<b-form-invalid-feedback class="text-12-semibold p-0 m-0"> {{
										$t('vui-long-nhap-mat-khau')
									}}</b-form-invalid-feedback>
								</div>
							</b-form-group>
							<b-button class="w-100 btn-general text-14 mt-2" type="submit"> {{ $t('dang-ky') }}
							</b-button>
							<div class="text-14 text-center pt-1">
								{{ $t('ban-da-co-tai-khoan') }}
								<span class="text-14-semibold text-danger pointer" @click="authenTabIndex = 0">{{
									$t('dang-nhap') }}
								</span>
							</div>
						</b-form>
					</b-tab>
				</b-tabs>
			</b-modal>

			<b-modal id="logout-modal" body-class="p-0" size="tiny" modal-class="text-center" hide-footer hide-header
				centered>
				<div class="text-16-semibold px-3 py-2">
					{{ $t('xac-nhan') }}
					<div class="text-14">{{ $t('ban-co-chac-chan-muon-dang-xuat') }}</div>
				</div>
				<div @click="$bvModal.hide('not-login-modal')">
					<div @click="logoutHandler" class="alert-modal-btn pointer text-16-semibold text-danger border-top">
						{{ $t('co')
						}}</div>
					<div class="alert-modal-btn pointer text-16 border-top" @click="$bvModal.hide('logout-modal')">{{
						$t('khong') }}
					</div>
				</div>
			</b-modal>

			<b-modal id="not-login-modal" body-class="p-0" size="tiny" modal-class="text-center" hide-footer hide-header
				centered>
				<div class="text-16-semibold px-3 py-2">
					{{ $t('ban-chua-dang-nhap') }}
					<div class="text-14">{{ $t('submit-comment-login') }}</div>
				</div>
				<div @click="$bvModal.hide('not-login-modal')">
					<div @click="$bvModal.show('login-modal')"
						class="alert-modal-btn pointer text-16-semibold text-danger border-top">{{ $t('dang-nhap') }}
					</div>
					<div class="alert-modal-btn pointer text-16 border-top">{{ $t('huy') }}</div>
				</div>
			</b-modal>

			<b-modal id="developer-info" body-class="p-2" header-class="p-2" size="small" hide-footer centered
				:title="$t('thong-tin-nha-phat-trien')" title-class="text-16-semibold text-center w-100">
				<div class="section-wrapper text-center p-3 mb-2">
					<img :src="urlLogoDEV" />
				</div>
				<div v-if="devInfo" class="section-wrapper text-14">
					<!-- <div class="py-1 px-2 border-bottom-item">
						<div>{{ $t('name') }}</div>
						<div class="font-weight-semibold">{{ devInfo.Name }}</div>
					</div> -->
					<div class="py-1 px-2 border-bottom-item">
						<div>Website</div>
						<div class="font-weight-semibold">{{ devInfo.Website }}</div>
					</div>
					<div class="py-1 px-2 border-bottom-item">
						<div>Hotline</div>
						<div class="font-weight-semibold">{{ devInfo.Phone }}</div>
					</div>
					<div class="py-1 px-2 border-bottom-item">
						<div>{{ $t('address') }}</div>
						<div class="font-weight-semibold">{{ devInfo.Address }}</div>
					</div>
				</div>
			</b-modal>

			<!-- change password -->

			<b-modal id="change-password-modal" body-class="p-2" header-class="p-2" size="small" hide-footer centered
				:title="'Đổi mật khẩu'" title-class="text-16-semibold text-center w-100">
				<b-form @submit="onSubmitChangePassword" autocomplete="off">
					<b-form-group :label="$t('form-password')" label-class="label-class">
						<div class="icon-input">
							<b-form-input :state="changePasswordFormState.CurrentPassword" autocomplete="on"
								class="form-control bg-white pr-4" :type="`${showPassChange ? 'text' : 'password'}`"
								v-model="changePasswordForm.CurrentPassword" :placeholder="$t('input-password')" />
							<span @click="showPassChange = !showPassChange">
								<img v-if="showPassChange" src="assets/image/icon/eye.svg" height="16px" />
								<img v-else src="assets/image/icon/eye-off.svg" height="16px" />
							</span>
							<b-form-invalid-feedback class="text-12-semibold p-0 m-0"> {{ $t('vui-long-nhap-mat-khau')
								}}
							</b-form-invalid-feedback>
						</div>
					</b-form-group>

					<b-form-group :label="$t('reset-new-password')" label-class="label-class">
						<div class="icon-input">
							<b-form-input :state="changePasswordFormState.NewPassword" autocomplete="on"
								class="form-control bg-white pr-4" :type="`${showPassChange1 ? 'text' : 'password'}`"
								v-model="changePasswordForm.NewPassword" :placeholder="$t('reset-new-pass-input')" />
							<span @click="showPassChange1 = !showPassChange1">
								<img v-if="showPassChange1" src="assets/image/icon/eye.svg" height="16px" />
								<img v-else src="assets/image/icon/eye-off.svg" height="16px" />
							</span>
							<b-form-invalid-feedback class="text-12-semibold p-0 m-0"> {{
								$t('vui-long-nhap-mat-khau-lan-2') }}
							</b-form-invalid-feedback>
						</div>
					</b-form-group>

					<b-form-group :label="$t('re-password-form')" label-class="label-class">
						<div class="icon-input">
							<b-form-input :state="changePasswordFormState.ReNewPassword" autocomplete="on"
								class="form-control bg-white pr-4" :type="`${showPassChange2 ? 'text' : 'password'}`"
								v-model="changePasswordForm.ReNewPassword" :placeholder="$t('re-password')" />
							<span @click="showPassChange2 = !showPassChange2">
								<img v-if="showPassChange2" src="assets/image/icon/eye.svg" height="16px" />
								<img v-else src="assets/image/icon/eye-off.svg" height="16px" />
							</span>
							<b-form-invalid-feedback class="text-12-semibold p-0 m-0">
								{{ rePasswordErrMessage }}
							</b-form-invalid-feedback>
						</div>
					</b-form-group>
					<b-button class="w-100 btn-general text-14 mt-2" type="submit">{{ $t('luu') }}</b-button>
				</b-form>
			</b-modal>

			<b-modal id="personal-info" body-class="p-2" header-class="p-2" size="small" hide-footer centered
				:title="'Thông tin tài khoản'" title-class="text-16-semibold text-center w-100">
				<b-tabs nav-class="d-none" v-model="person_info_tab_index">
					<b-tab>
						<div class="section-wrapper text-center p-2 mb-2">
							<b-row no-gutters class="text-left">
								<b-col sm="2" class="avatar-icon pointer"
									:style="`background-image: url('/assets/image/NLT-INFO/avatar.svg'); width: 48px`"></b-col>
								<b-col sm="10" class="pl-2 limit-text">
									<div class="text-18 pointer">{{ formDataUser.FullName }}</div>
									<div class="text-14">
										{{ formDataUser.UserDescription }}
									</div>
								</b-col>
							</b-row>
						</div>
						<div class="section-wrapper text-14">
							<div class="py-1 px-2 border-bottom-item">
								<div>{{ $t('user-name') }}</div>
								<div class="font-weight-semibold">{{ formDataUser.UserPhone }}</div>
							</div>
							<div class="py-1 px-2 border-bottom-item">
								<div>{{ $t('email') }}</div>
								<div class="font-weight-semibold">{{ formDataUser.UserEmail }}</div>
							</div>
							<div class="py-1 px-2 border-bottom-item">
								<div>{{ $t('dia-chi') }}</div>
								<div class="font-weight-semibold">{{ formDataUser.Address }}</div>
							</div>
						</div>
						<button class="text-14-semibold w-100 btn-change-info mt-1"
							@click="person_info_tab_index = 1">{{
								$t('thay-doi-thong-tin') }}</button>
					</b-tab>
					<b-tab>
						<div class="text-14 mb-2">
							<b-form-group :label="$t('user-name')" label-class="label-class">
								<b-form-input v-model="formDataUser.FullName" class="form-control bg-white"
									:placeholder="$t('nhap-ten-nguoi-dung')" />
							</b-form-group>
							<b-form-group :label="$t('so-dien-thoai')" label-class="label-class">
								<b-form-input v-model="formDataUser.UserPhone" class="form-control bg-white"
									:placeholder="$t('nhap-so-dien-thoai')" />
							</b-form-group>
							<b-form-group :label="$t('email')" label-class="label-class">
								<b-form-input v-model="formDataUser.UserEmail" class="form-control bg-white"
									:placeholder="$t('nhap-email')" />
							</b-form-group>
							<b-form-group :label="$t('dia-chi')" label-class="label-class">
								<b-form-input v-model="formDataUser.Address" class="form-control bg-white"
									:placeholder="$t('nhap-dia-chi')" />
							</b-form-group>
							<b-form-group :label="$t('mo-ta')" label-class="label-class">
								<b-form-textarea v-model="formDataUser.UserDescription" row="2"
									:placeholder="$t('nhap-mo-ta')" />
							</b-form-group>
						</div>
						<div style="height: 30px" class="d-flex">
							<button class="text-14-semibold w-100 btn-change-info h-100 mr-1"
								@click="person_info_tab_index = 0">{{
									$t('huy') }}</button>
							<b-button class="w-100 btn-general h-100 ml-1" @click="changeUserInfo">{{ $t('luu')
								}}</b-button>
						</div>
					</b-tab>
				</b-tabs>
			</b-modal>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ImageCard from '../components/Cards/ImageCard.vue';
import RepositoryFactory from '@/repository/factory';
const authenticationUserGateWay = RepositoryFactory.get('authenticationUserGateWay');
const guestPost = RepositoryFactory.get('guestPost');

import { convertDate } from '@/utils';
import { urlLogoDEV } from '@/constants/config';

export default {
	name: 'main-navbar',

	components: {
		ImageCard,
	},
	data() {
		return {
			urlLogoDEV,
			menuActive: localStorage.getItem('currentUrl'),
			path: this.$root._route.fullPath,
			currentLanguage: '',
			localeOption: [
				{ id: 'vn', name: 'Tiếng Việt', icon: '/assets/image/vietnam.png' },
				{ id: 'en', name: 'English', icon: '/assets/image/english.png' },
			],

			loginForm: {
				name: null,
				pass: null,
			},
			registerForm: {
				username: null,
				email: null,
				phone: null,
				pass: null,
			},

			changePasswordForm: {
				CurrentPassword: null,
				NewPassword: null,
				ReNewPassword: null,
			},

			changePasswordFormState: {
				CurrentPassword: null,
				NewPassword: null,
				ReNewPassword: null,
			},

			loginFormState: {
				name: null,
				pass: null,
			},

			registerFormState: {
				username: null,
				email: null,
				phone: null,
				pass: null,
			},

			showPass: false,
			showPassChange: false,
			showPassChange1: false,
			showPassChange2: false,
			authenTabIndex: 0,
			rePasswordErrMessage: '',
			person_info_tab_index: 0,
			formDataUser: {},
			devInfo: null,
			topPost: []
		};
	},

	computed: {
		...mapGetters(['currentUser', 'processing', 'loginError']),
		invalidFeedback() {
			return this.$t('valid_enterAllRequiredInformation');
		},

		isLoggedIn() {
			return this.currentUser ? true : false;
		},
	},

	watch: {
		loginError(val) {
			if (val != null) {
				this.$notify(
					{
						type: 'system',
						category: this.$t('thong-bao-he-thong'),
						date: this.convertDate(new Date()),
						title: this.$t('dang-nhap-that-bai'),
						message: val,
					},
					{
						duration: 2000,
						permanent: false,
					}
				);
			}
		},
	},
	created() {
		this.getTopPost()
		this.getCurrentLanguage();
		localStorage.setItem('listLanguage', JSON.stringify(this.localeOption));
	},

	methods: {
		...mapActions(['login', 'signOut', 'setLang', 'register', 'setLeftMenuIndex', 'setNewsDetail']),

		showNewsHandler(item) {
			this.setNewsDetail(item)
			this.$bvModal.show('detail-event-modal')
		},

		async getInfoCompany() {
			const response = await authenticationUserGateWay.GetInfoNoAuther();
			this.devInfo = response.status ? response.data[0] : null;
			this.$bvModal.show('developer-info');
		},

		async viewUserInfo() {
			this.getUserInfo();
			this.$bvModal.show('personal-info');
		},

		async getUserInfo() {
			const response = await authenticationUserGateWay.GetInfo();
			if (response.status) {
				this.formDataUser = response.data[0].InfoUserdataResponse[0];
			}
		},

		async changeUserInfo() {
			const body = { ...this.formDataUser };
			const response = await authenticationUserGateWay.ChangeInfo(body);
			if (response.status) {
				this.$notify(
					{
						type: 'system',
						category: this.$t('thong-bao-he-thong'),
						date: this.convertDate(new Date()),
						title: this.$t('cap-nhat-thong-tin-thanh-cong'),
					},
					{
						duration: 2000,
						permanent: false,
					}
				);
				this.$bvModal.hide('personal-info');
				this.getUserInfo();
			} else {
				this.$notify(
					{
						type: 'system',
						category: this.$t('thong-bao-he-thong'),
						date: this.convertDate(new Date()),
						title: this.$t('cap-nhat-thong-tin-that-bai'),
						message: response?.message || '',
					},
					{
						duration: 2000,
						permanent: false,
					}
				);
			}
		},

		// logout
		async logoutHandler() {
			const response = await authenticationUserGateWay.LogoutGateWay();
			if (response.status) {
				this.signOut();
				this.$notify(
					{
						type: 'system',
						category: this.$t('thong-bao-he-thong'),
						date: this.convertDate(new Date()),
						title: this.$t('dang-xuat-thanh-cong'),
					},
					{
						duration: 2000,
						permanent: false,
					}
				);
				this.$bvModal.hide('logout-modal');
				this.setLeftMenuIndex(0);
			}
		},

		// change password
		async onSubmitChangePassword(event) {
			event.preventDefault();
			let body = {
				CurrentPassword: this.changePasswordForm.CurrentPassword,
				NewPassword: this.changePasswordForm.CurrentPassword,
			};
			// validate
			this.changePasswordFormState = {
				CurrentPassword: this.changePasswordForm.CurrentPassword?.trim().length > 0 ? null : false,
				NewPassword: this.changePasswordForm.NewPassword?.trim().length > 0 ? null : false,
				ReNewPassword: this.changePasswordForm.ReNewPassword?.trim().length > 0 ? null : false,
			};
			if (!this.changePasswordForm.ReNewPassword) {
				this.rePasswordErrMessage = this.$t('chua-nhap-lai-mat-khau');
			} else if (this.changePasswordForm.ReNewPassword != this.changePasswordForm.NewPassword) {
				this.changePasswordFormState.ReNewPassword = false;
				this.rePasswordErrMessage = this.$t('mat-khau-nhap-lai-khong-khop');
			}

			const isValidForm = Object.entries(this.changePasswordFormState).every((item) => item[1] == null);
			if (!isValidForm) return;

			const response = await authenticationUserGateWay.ChangePassword(body);
			if (response.status) {
				this.$notify(
					{
						type: 'system',
						category: this.$t('thong-bao-he-thong'),
						date: this.convertDate(new Date()),
						title: this.$t('doi-mat-khau-thanh-cong'),
					},
					{
						duration: 2000,
						permanent: false,
					}
				);
				this.$bvModal.hide('change-password-modal');
				this.resetAllForm();
			} else {
				this.$notify(
					{
						type: 'system',
						category: this.$t('thong-bao-he-thong'),
						date: this.convertDate(new Date()),
						title: 'Đổi mật khẩu thất bại',
						message: response?.message || '',
					},
					{
						duration: 2000,
						permanent: false,
					}
				);
			}
		},
		// login
		async onSubmitLogin(event) {
			event.preventDefault();
			let body = {
				UserName: this.loginForm.name,
				UserPassword: this.loginForm.pass,
				CmpnID: '0',
			};
			// validate
			this.loginFormState = {
				name: this.loginForm.name?.trim().length > 0 ? null : false,
				pass: this.loginForm.pass?.trim().length > 0 ? null : false,
			};
			const isValidForm = Object.entries(this.loginFormState).every((item) => item[1] == null);
			if (!isValidForm) return;
			this.login(await authenticationUserGateWay.Login(body));
			if (!this.loginError) {
				const response = await authenticationUserGateWay.GetInfo();
				if (response.status) {
					this.$notify(
						{
							type: 'system',
							category: this.$t('thong-bao-he-thong'),
							date: this.convertDate(new Date()),
							title: this.$t('dang-nhap-thanh-cong'),
						},
						{
							duration: 2000,
							permanent: false,
						}
					);
					location.reload();
					this.resetAllForm();
					this.$bvModal.hide('login-modal');
				}
			}
		},
		// đăng ký
		async onSubmitRegister(event) {
			event.preventDefault();
			let body = {
				UserPhone: this.registerForm.phone,
				UserPassword: this.registerForm.pass,
				UserEmail: this.registerForm.email,
				FullName: this.registerForm.username,
			};
			// validate
			this.registerFormState = {
				username: this.registerForm.username?.trim().length > 0 ? null : false,
				pass: this.registerForm.pass?.trim().length > 0 ? null : false,
				email: this.registerForm.email?.trim().length > 0 ? null : false,
				phone: this.registerForm.phone?.trim().length > 0 ? null : false,
			};
			const isValidForm = Object.entries(this.registerFormState).every((item) => item[1] == null);
			if (!isValidForm) return;
			const response = await authenticationUserGateWay.Register(body);
			if (response.status) {
				this.$notify(
					{
						type: 'system',
						category: this.$t('thong-bao-he-thong'),
						date: this.convertDate(new Date()),
						title: this.$t('dang-ky-thanh-cong'),
					},
					{
						duration: 2000,
						permanent: false,
					}
				);
				this.authenTabIndex = 0;
				this.resetAllForm();
			} else {
				this.$notify(
					{
						type: 'system',
						category: this.$t('thong-bao-he-thong'),
						date: this.convertDate(new Date()),
						title: this.$t('dang-ky-that-bai'),
						message: response.message,
					},
					{
						duration: 2000,
						permanent: false,
					}
				);
			}
		},

		getCurrentLanguage() {
			if (localStorage.getItem('currentLanguage')) {
				let currentLanguage = localStorage.getItem('currentLanguage');
				this.currentLanguage = currentLanguage === 'vn' || currentLanguage === 'en' ? localStorage.getItem('currentLanguage') : 'vn';
				this.$i18n.locale = this.currentLanguage;
			} else {
				this.currentLanguage = 'vn';
				this.$i18n.locale = this.currentLanguage;
			}
		},

		resetAllForm() {
			this.loginForm = {
				name: null,
				pass: null,
			};
			this.registerForm = {
				username: null,
				email: null,
				phone: null,
				pass: null,
			};

			this.changePasswordForm = {
				CurrentPassword: null,
				NewPassword: null,
				ReNewPassword: null,
			};

			this.changePasswordFormState = {
				CurrentPassword: null,
				NewPassword: null,
				ReNewPassword: null,
			};

			this.loginFormState = {
				name: null,
				pass: null,
			};

			this.registerFormState = {
				username: null,
				email: null,
				phone: null,
				pass: null,
			};
		},

		changeLocale(locale) {
			this.$i18n.locale = locale;
			localStorage.setItem('currentLanguage', locale);
			location.reload();
		},

		convertDate(payload) {
			return convertDate(payload);
		},

		//temporary for notify popover

		async getTopPost() {
			const response = await guestPost.Get({
				PageNumber: 1,
				PageSize: 5,
				CategoryType: 'POST',
			});
			this.topPost = response.status ? response.data : [];

		},
	},
};
</script>
<style lang="scss" scoped>
.avatar-icon {
	display: inline-block;
	border-radius: 50%;
	aspect-ratio: 1/1;
	background-position: center;
	background-repeat: no-repeat;
	background-size: 100% auto;
	background-blend-mode: color;
}

.limit-text {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}

.wide-popover-notify {
	min-width: 359px !important;
	max-width: 359px !important;
	background: #fcfcfcf2;
	backdrop-filter: blur(25px);

	.notify-icon {
		width: 16px;
	}
}

.wide-popover-authen {
	min-width: 320px !important;
	max-width: 320px !important;
	background: #fcfcfcf2;
	backdrop-filter: blur(25px);
}

.underline-hover:hover {
	text-decoration: underline;
}

.notify-bounder {
	width: 24px;
	height: 24px;
	padding: 2px;
	border-radius: 6px;
	transition: all 0.2s;
}

.notify-bounder:hover {
	background: #e5e6eb;
}

.list-notify-container {
	height: 600px;
	overflow: overlay !important;
}

.list-notify-container::-webkit-scrollbar {
	width: 0.4em;
}

.list-notify-container::-webkit-scrollbar-thumb {
	background: transparent !important;
}

.list-notify-container:hover::-webkit-scrollbar-thumb {
	background: #b9b9b9 !important;
}

.b-tab-container {
	transition: all 0.5s;
}

.icon-input {
	position: relative;

	span {
		position: absolute;
		right: 2%;
		top: 0px;
		cursor: pointer;
	}
}
</style>

<style>
.event-modal-body {
	background: #fcfcfc !important;
}
</style>
